<template>
  
<div class="container-body-flex-wedding"> 
  
    <cWedding/>
</div>

</template>


<script>
import linkmenuleftwedding from './MenuLeftWedding'
import cWedding from './ContainerWedding'
export default {
    components:{linkmenuleftwedding,cWedding},

 data(){
        return{   
        }
    }
};

</script>

<style scoped>
.container-body-flex-wedding{
    display: flex;
    margin: 0 auto;
    width: 96%;
   
}

</style>
